import { collection,getDocs } from 'firebase/firestore'  
import { db } from './firebase-config';
import {useState,useEffect} from 'react'



export function ReadData(dataName){
const [Data , setData] = useState()
const dataRef = collection(db,String(dataName))
useEffect(()=>{
 DataFetching();

// eslint-disable-next-line
},[])
const DataFetching = async ()=>{
    const data = await getDocs(dataRef);
    setData(data.docs.map((recData) => ({ ...recData.data(), id: recData.id })))
    
}
if(Data){
    return Data;
}
else{
    
}

} 
